<div
	class="full-width m-b-1 parent-container"
	*ngIf="(projectDetailsStore.projectGroups$ | ngrxPush)?.length"
	[ngStyle]="{ height: getContainerHeight() }"
>
	<div
		*ngFor="let projectGroup of projectDetailsStore.projectGroups$ | ngrxPush; let i = index"
		[ngClass]="{ 'm-t-1': i != 0 }"
		class="parent-card"
	>
		<mat-card
			class="cursor-pointer project_group_container"
			(click)="onProjectGroupCardClick(projectGroup, $event)"
			[ngClass]="{
				'panel-selected mat-elevation-z4 selected_group_container':
					selectedProjectGroupIds.indexOf(projectGroup.id) > -1,
			}"
		>
			<mat-card-content>
				<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
					<div fxFlex class="font-size-16 font-weight-bold primary-text">
						{{ projectGroup.name }}
					</div>
					<div fxFlex class="font-size-14 primary-text">{{ projectGroup.numberOfCarriers }} Carriers</div>
					<div fxFlex class="font-size-14 primary-text">
						Rates:
						<span
							*ngIf="projectGroup.minimumRate && projectGroup.maximumRate; else rateNA"
							class="font-size-14"
						>
							{{ TO_DOLLARS(projectGroup.minimumRate) | currency: 'USD' : 'symbol' : '1.0-0' }} -
							{{ TO_DOLLARS(projectGroup.maximumRate) | currency: 'USD' : 'symbol' : '1.0-0' }}
						</span>
					</div>
					<div fxFlex="10" class="font-size-14 primary-text">Trucks: {{ projectGroup.trucksCount }}</div>
					<div fxFlex="10" class="font-size-14 primary-text">Lanes: {{ projectGroup.lanesCount }}</div>
					<div fxFlex class="font-size-14 primary-text">
						Contact:
						{{
							DELAY_CONTACT_LABELS[projectGroup.delayByMinutes]
								? DELAY_CONTACT_LABELS[projectGroup.delayByMinutes]
								: projectGroup.delayByMinutes + ' minutes later'
						}}
					</div>
					<div fxFlex="5" fxLayoutAlign="end center">
						<mat-icon
							class="primary-light-color cursor-pointer"
							matTooltipClass="custom-tooltip-width"
							*ngIf="projectGroup.id !== selectedProjectGroupId"
						>
							expand_more
						</mat-icon>
						<mat-icon
							*ngIf="projectGroup.id === selectedProjectGroupId"
							class="primary-light-color cursor-pointer"
							matTooltipClass="custom-tooltip-width"
						>
							expand_less
						</mat-icon>
					</div>
				</div>
			</mat-card-content>
		</mat-card>

		<ng-template [ngIf]="projectGroup.id === selectedProjectGroupId">
			<div class="m-t-0-5"></div>

			<div class="child-container" [ngStyle]="{ height: getChildViewportHeight() }">
				<app-procured-carriers
					#groupCarriersComponent
					[isLoadingProjectsList]="false"
					[projectCarrierMapList]="projectGroup.projectCarrierMapsList"
					[totalNumberOfProjects]="projectGroup.projectCarrierMapsList?.length"
					[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIds"
					[usersList]="projectDetailsStore.usersList$ | async"
					[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
					[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
					[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
					[showProcuredCarriersForGroup]="true"
					[isWorkflowProject]="isWorkflowProject"
					[carrierAllocationsMap]="carrierAllocationsMap"
					(panelClicked)="onProcuredCarrierClick($event)"
					(openFullProfileEvent)="openFullProfileEvent.emit($event)"
					(editAllocationEvent)="editAllocationEvent.emit($event)"
				></app-procured-carriers>
			</div>
		</ng-template>
	</div>
</div>

<ng-template #rateNA> N/A </ng-template>
